import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IMeter, IPage } from 'common/src/types/interfaces';
import { ICreateMeterDto, IUpdateMeterDto } from 'common/src/types/meter.dtos';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getMeters = async (
  params: DataQueryParams = {},
): Promise<IPage<IMeter>> => {
  return await getRequest(API_BASE_PATHS.METERS, formatQueryParams(params));
};

export const getMeter = async (id: string): Promise<IMeter> =>
  await getRequest(`${API_BASE_PATHS.METERS}/${id}`);

export const addMeter = async (body: ICreateMeterDto): Promise<string> =>
  await postRequest(API_BASE_PATHS.METERS, {}, body);

export const updateMeter = async (
  id: string,
  body: IUpdateMeterDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.METERS}/${id}`, {}, body);

export const deleteMeter = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.METERS}/${id}`, {});
